import Button from 'tailwind-components/Button/Button';
import React, { useState } from 'react';
import Separator from 'tailwind-components/Separator/Separator';
import BulkOnboardingModal from './BulkOnboardingModal';
import { Upload } from 'lucide-react';

/**
 * entry point for the bulk onboarding invites flow (ONEILL-886) — O'Neill only.
 * rendered inside the "Agency Onboarding Invites" card, next to the single
 * SignupAgents form. opens the two-tab modal (Download Template / Upload File).
 */
export default function BulkOnboardingUpload() {
  const [open, setOpen] = useState(false);

  return (
    <div className='mt-6'>
      <Separator />
      <div className='mt-4 flex flex-col gap-1'>
        <p className='m-0 font-semibold'>Invite many agents at once</p>
        <p className='m-0 text-sm text-grey'>
          Upload a CSV file to send onboarding invites to multiple agents in
          a single step.
        </p>
        <div className='mt-2'>
          <Button
            variant='secondary'
            size='medium'
            rounded='small'
            text='Bulk upload'
            icon={<Upload size={18} />}
            onClick={() => setOpen(true)}
          />
        </div>
      </div>
      <BulkOnboardingModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
